import { createFileRoute } from "@tanstack/react-router";
import { CrudTable } from "@/features/admin/components/CrudTable";

export const Route = createFileRoute("/_authenticated/admin/learning-paths")({
  component: () => (
    <CrudTable
      title="Learning Paths"
      table="learning_paths"
      orderBy={{ column: "step_number", ascending: true }}
      columns={[
        { key: "step_number", label: "Step" },
        { key: "title_en", label: "Title (EN)" },
        { key: "title_ar", label: "Title (AR)" },
        { key: "color_class", label: "Color" },
      ]}
      fields={[
        { key: "step_number", label: "Step Number", type: "number", required: true },
        { key: "title_en", label: "Title (EN)", required: true },
        { key: "title_ar", label: "Title (AR)", required: true },
        { key: "description_en", label: "Description (EN)", type: "textarea", required: true },
        { key: "description_ar", label: "Description (AR)", type: "textarea", required: true },
        {
          key: "color_class",
          label: "Color Class (e.g. bg-fun-yellow)",
          defaultValue: "bg-fun-yellow",
        },
      ]}
    />
  ),
});
